import { configured, lastSeen, mfgId, powerSource, reachable } from '~/helpers/fields-description';
import { WirelessSwitch } from './WirelessSwitch.model';

export class NLDC extends WirelessSwitch {
    isWired = true;

    get fieldSubtype() {
        return undefined;
    }
    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.reachable ? '' : 'error--text');
    }
    get fieldConfigured() {
        return configured(this.configured);
    }
    get fieldMfgId() {
        return mfgId(typeof this.mfg_id !== 'undefined' ? this.mfg_id : undefined);
    }
    get fieldReachable() {
        return reachable(this.reachable);
    }
    get fieldPowerSource() {
        return powerSource(this.isWired ? 'Wired' : 'Battery');
    }
}
